/**
 * Genera opciones de ECharts para el modelo Bradley
 * @param {Object} dataBradley - JSON con datos del modelo Bradley
 * @returns {Object} Configuración de opciones para ECharts
 */
export function bradleyChart(dataBradley) {
  if (!dataBradley || !dataBradley.niveles_bradley) {
    return {};
  }

  const niveles = dataBradley.niveles_bradley || [];
  const curvaRef = niveles.map((n) => {
    return (dataBradley.curva_referencia && dataBradley.curva_referencia[n]) || 0;
  });
  const curvaPlanta = niveles.map((n) => {
    return (dataBradley.curva_planta && dataBradley.curva_planta[n]) || 0;
  });
  const posicionActual = dataBradley.posicion_actual || {};
  const mensajeClave = dataBradley.mensaje_clave || '';

  return {
    backgroundColor: '#ffffff',

    title: {
      text: 'Modelo Bradley – Posición de la planta',
      subtext: mensajeClave,
      left: 'center',
      top: '3%',
      textStyle: { fontSize: 18, fontWeight: 'bold' },
      subtextStyle: { fontSize: 12, color: '#666' }
    },

    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        if (!params || params.length === 0) return '';
        var txt = params
          .map(function (p) {
            return p.seriesName + ': ' + parseFloat(p.data).toFixed(1);
          })
          .join('<br/>');
        return params[0].axisValue + '<br/>' + txt;
      }
    },

    legend: {
      data: ['Curva de referencia', 'Situación actual planta'],
      top: '16%',
      left: 'center'
    },

    grid: {
      left: '10%',
      right: '6%',
      top: '24%',
      bottom: '15%'
    },

    xAxis: {
      type: 'category',
      data: niveles,
      boundaryGap: false,
      axisLine: { lineStyle: { color: '#666' } },
      axisLabel: { fontSize: 12 }
    },

    yAxis: {
      type: 'value',
      name: 'Índice de incidentes (normalizado)',
      nameTextStyle: {
        fontSize: 10,
      },
      nameGap: 40,
      min: 0,
      max: 100,
      axisLine: { lineStyle: { color: '#666' } },
      splitLine: { lineStyle: { color: '#eee' } },
      axisLabel: { formatter: '{value}' }
    },

    visualMap: {
      show: false,
      dimension: 0,
      pieces: [
        { lte: 0, color: 'rgba(255,0,0,0.04)' },
        { gt: 0, lte: 1, color: 'rgba(255,215,0,0.04)' },
        { gt: 1, lte: 2, color: 'rgba(173,216,230,0.04)' },
        { gt: 2, color: 'rgba(0,176,80,0.04)' }
      ]
    },

    series: [
      {
        name: 'Curva de referencia',
        type: 'line',
        smooth: 0.7,
        data: curvaRef,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: {
          width: 2,
          color: '#b3b3b3',
          type: 'dashed'
        },
        itemStyle: { color: '#b3b3b3', opacity: 0.7 },
        areaStyle: { opacity: 0.03 },
        z: 1
      },

      {
        name: 'Situación actual planta',
        type: 'line',
        smooth: 0.8,
        data: curvaPlanta,
        symbol: 'circle',
        symbolSize: 10,
        lineStyle: {
          width: 4,
          color: '#0070C0'
        },
        itemStyle: { color: '#0070C0' },
        areaStyle: { opacity: 0.1 },
        z: 3,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          fontSize: 11,
          color: '#00508a'
        },

        markPoint: {
          data: [
            {
              name: 'Posición actual',
              coord: [
                posicionActual.nivel || '',
                posicionActual.ratio_incidentes || 0
              ],
              symbol: 'circle',
              symbolSize: 14,
              itemStyle: { color: '#0070C0' },
              label: {
                show: true,
                position: 'top',
                formatter: 'Actual – ' + (posicionActual.nivel || ''),
                color: '#0070C0',
                fontSize: 11,
                fontWeight: 'bold',
                backgroundColor: '#ffffff',
                padding: [2, 4],
                borderRadius: 3
              }
            }
          ]
        }
      }
    ],

    graphic: generateZonasCulturales(dataBradley.zonas_culturales)
  };
}

/**
 * Genera elementos gráficos para las zonas culturales
 * @param {Array} zonas - Array de zonas culturales
 * @returns {Array} Array de elementos gráficos para ECharts
 */
function generateZonasCulturales(zonas) {
  if (!zonas || !Array.isArray(zonas)) {
    return [];
  }

  return zonas.map((zona) => {
    const posicion = zona.posicion || { left: '10%', top: '50%' };
    const etiqueta = zona.etiqueta || {};
    return {
      type: 'text',
      left: posicion.left,
      top: posicion.top,
      style: {
        text: etiqueta.texto || '',
        fill: etiqueta.color_texto || '#000',
        fontSize: 11,
        fontWeight: 'bold',
        textAlign: 'left'
      }
    };
  });
}
